import React from "react";

function Column(props: any) {
  const { ducks, handleSelection, current, loading } = props;
  return (
    <div className="relative flex flex-col items-center justify-between rounded-3xl og-bg-opacity-black h-full w-full md:w-3/12 pb-5 px-2 pt-5 overflow-hidden">
    <div
        className="flex flex-row flex-wrap items-center justify-around m-auto h-full overflow-scroll"
      >
        {(!ducks && !loading) && 
          <div className="uppercase font-bold txt-white text-7xl md:text-6xl w-4/5 text-center m-auto">
            PLEASE SELECT A FILTER
          </div>
        }
        {
          loading && 
          <div className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        }
        {!!ducks && ducks.map((i:any, index:any) => (
          <div key={index} className="w-5/12 my-3 relative resize" onClick={()=> {handleSelection(i)}}>
            <img src={i.image_url} alt="" className={`rounded-lg resize ${current && (i.token_id === current.token_id) ? 'border-8	selected-img' : ''}`}/>
            <div className="absolute left-2 bottom-2 txt-white text-6xl md:text-sm rounded-lg og-bg-opacity-black py-1 px-2">
              #{i.token_id}
            </div>
          </div>
        ))}
      </div>
  </div>
  );
}

export default Column;